import { useState } from 'react';
import api from 'api';
import { actions } from 'store';
import { useDispatch, useReduxState } from 'hooks';
import { Button } from 'components/common';
import { DropdownButton } from 'components/common/dropdown';

import type { DropdownButtonInterface } from 'components/common/dropdown/DropdownButton';

interface Props extends DropdownButtonInterface {
  data: any;
  isDropdown?: boolean;
  onSuccess?: (data: any) => void;
  successMessage: string;
  url: string;
}

const ApiPostButton = ({
  data,
  isDropdown,
  onSuccess,
  successMessage,
  url,
  ...props
}: Props) => {
  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (ev) => {
    if (ev) ev.stopPropagation();

    try {
      setIsLoading(true);

      const response = await api.post(url, data);

      if (onSuccess) await onSuccess(response.data);

      setIsLoading(false);

      // click outside dropdown to close it
      if (isDropdown) document.body.click();

      dispatch(actions.addNotice({ text: successMessage, type: 'success' }));
    } catch (err) {
      setIsLoading(false);
      await dispatch.handleErrorDispatch(err);
    }
  };

  return isDropdown ? (
    <DropdownButton
      loading={isLoading}
      onClick={handleSubmit}
      data-keep-open={true}
      {...props}
    />
  ) : (
    <Button loading={isLoading} onClick={handleSubmit} {...props} />
  );
};

export default ApiPostButton;
